export type Cents = number & { readonly __brand: 'Cents' };
export type PlainDate = string & { readonly __brand: 'PlainDate' };
export interface Fraction {
  readonly num: number;
  readonly den: number;
}
export interface Issue {
  readonly code: string;
  readonly field?: string;
  readonly details?: Readonly<Record<string, string | number | boolean>>;
}
export type Result<T> =
  | { readonly ok: true; readonly value: T }
  | { readonly ok: false; readonly issues: readonly Issue[] };
export type AwardTypeCode = 'SDB' | 'EDB' | 'PAA' | 'TAA' | 'SPOT';
/** APP-264: 'spot' is the Spot Awards pool, company-wide and without a sector. */
export type PoolKind = 'sector' | 'executive' | 'paa_taa' | 'spot';
export type CostType = 'OH' | 'GA';
export interface Pool {
  readonly id: string;
  readonly kind: PoolKind;
  readonly sectorId: string | null;
  readonly name: string;
}
export interface PersonFacts {
  readonly personId: string;
  readonly sectorId: string | null;
  readonly homeOrg: string | null;
  readonly costType: CostType;
  readonly managerId: string | null;
  readonly status: 'active' | 'left';
}

export function success<T>(value: T): Result<T> {
  return { ok: true, value };
}
export function failure<T = never>(code: string, field?: string): Result<T> {
  return { ok: false, issues: [{ code, ...(field === undefined ? {} : { field }) }] };
}
